import { render, staticRenderFns } from "./RootLogView.vue?vue&type=template&id=71531c64&"
import script from "./RootLogView.vue?vue&type=script&lang=ts&"
export * from "./RootLogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports